import { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import { createClient } from "./clientFactory";
import { handleHttpErrors } from "./errorHandler";

let authorizationToken: string | null = null;

export default class ApiClient {
    private client: AxiosInstance;

    constructor(basePath: string = "", baseUrl: string) {
        this.client = createClient({
            baseURL: `${baseUrl}${basePath}`,
        });
    }

    private request(config: AxiosRequestConfig): Promise<any> {
        if (authorizationToken !== null) {
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${authorizationToken}`,
            };
        }

        return this.client
            .request({
                ...config,
            })
            .then((response) => Promise.resolve(response))
            .catch((error: AxiosError) => handleHttpErrors(error));
    }

    public static setAuthorizationToken(token: string): void {
        authorizationToken = token;
    }

    public get(url: string, config: AxiosRequestConfig = {}) {
        return this.request({ ...config, url, method: "GET" });
    }

    public delete(url: string, config: AxiosRequestConfig = {}) {
        return this.request({ ...config, url, method: "DELETE" });
    }

    public head(url: string, config: AxiosRequestConfig = {}) {
        return this.request({ ...config, url, method: "HEAD" });
    }

    public post(url: string, data: object = {}, config: AxiosRequestConfig = {}) {
        return this.request({ ...config, url, method: "POST", data });
    }

    public put(url: string, data: object = {}, config: AxiosRequestConfig = {}) {
        return this.request({ ...config, url, method: "PUT", data });
    }

    public patch(url: string, data: object = {}, config: AxiosRequestConfig = {}) {
        return this.request({ ...config, url, method: "PATCH", data });
    }
}
